export const rose = {
    rose: {
        style: {
            fillOpacity: 1
        }
    },
    label: {
        style: {
            lineWidth: 2,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            },
            textAlign: "center",
            textBaseline: "middle"
        }
    }
};
//# sourceMappingURL=rose.js.map
